import axios from 'axios';

export interface User {
  email: string;
  is_active: boolean;
  jnid: string;
  name: string;
  phone: string;
  id?: number | string;
}

class UsersService {
  async getActiveUsers(
    accessToken: string,
    api1Origin: string
  ): Promise<User[]> {
    try {
      const response = await axios.get(`${api1Origin}/api2/users`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.data) {
        return [];
      }

      let users = response.data;
      users = users.filter((user) => user.is_active === true);

      return [...users];
    } catch (error) {
      console.log('error: ' + JSON.stringify(error));
      return [];
    }
  }
}

export const usersService = new UsersService();
